export default __webpack_public_path__ + "static/media/success.a890b453.png";